import { __assign } from "tslib";
window.__INITIAL_STATE__ = window.__INITIAL_STATE__ || {};
var initialState = __assign({}, window.__INITIAL_STATE__);
/** @type {'daily' | 'pre' | 'prod'} */
var env = initialState.env;
if (!env) {
    if (window.location.host.endsWith('.test')) {
        env = 'daily';
    }
    else if (window.location.host.startsWith('pre-')) {
        env = 'pre';
    }
    else {
        env = 'prod';
    }
}
var app = (initialState.apps && initialState.apps[0]) || {};
// @TODO 更合适的方式是增加 globalConfig 初始化过程
// 是沙箱环境下，就把敏感的信息删掉
if (window.__SANDBOX_ENV__ === 'VM') {
    var canBeReservedKeysInVM_1 = [
        'env',
        'runtimeEnv',
        'featureGroup',
        'apiGatewayDomain',
        'isSolutionWebApp',
        'isOfficial',
        'isSolutionPreview',
        'templates',
    ];
    Object.keys(window.__INITIAL_STATE__).forEach(function (key) {
        if (!canBeReservedKeysInVM_1.includes(key)) {
            delete window.__INITIAL_STATE__[key];
        }
    });
}
var config = {
    auid: initialState.auid,
    csrfToken: initialState.csrfToken,
    tenantId: initialState.tenantId,
    // 运行态 host
    saasHost: initialState.saasHost,
    // appHost 比 saasHost 多了一个 appId
    // 并且 vpc 情况下，会把 vpc-instanceId  & regionId 都会拼到这个 appId 的字段上
    appHost: initialState.appHost,
    projectId: initialState.projectId,
    projectName: initialState.projectName,
    appDetail: initialState.appDetail,
    appId: app.app_id,
    appName: initialState.appName
        || app.app_name
        || (initialState.appDetail && initialState.appDetail.name),
    // 应用 appKey
    appKey: initialState.appKey,
    // apigw 的域名
    apiGatewayDomain: initialState.apiGatewayDomain,
    // 当前处于什么环境: EDIT RUNTIME
    runtimeEnv: initialState.runtimeEnv,
    // 当前处于哪种运行态下
    runtimeHost: initialState.runtimeHost,
    customDomain: initialState.custom_domain,
    // 安全要求的页面访问 token
    pageToken: initialState.page_token,
    portalHost: initialState.portalHost,
    buildTarget: initialState.buildTarget || 'app',
    productKey: initialState.productKey,
    pluginId: initialState.pluginId,
    // 当前应用的页面列表
    pageList: initialState.pageList,
    // 当前页dsl
    pageConfigDSL: initialState.pageConfigDSL,
    // 当前页组件列表
    pageComponents: initialState.pageComponents,
    // web 工作台版本
    webWorkbenchVersion: initialState.webWorkbenchVersion,
    // 当前应用用到的组件工作台的组件列表
    workbenchComponents: initialState.workbenchComponents || [],
    // 开发者社区 HOST
    developerPlatformHost: initialState.developerPlatformHost || [],
    // 组件工作台的官方组件的文档映射
    componentWorkbenchDocMap: initialState.componentWorkbenchDocMap || {},
    // 母版列表 { <masterId>: { name, dsl } }
    masterMap: initialState.masterMap || {},
    // webSocket 长连接服务器地址
    wsUrl: initialState.wsUrl,
    // 是不是解决方案预览，解决方案预览时，前端注入
    isSolutionPreview: initialState.isSolutionPreview,
    // 禁止应用更新
    appOperationDisabled: !!initialState.isSolutionPreview,
    /** 部署环境：日常/预发/线上
      * @type {'daily' | 'pre' | 'prod'}
      */
    env: env,
    // POP 接口的区域：预发是 hangzhou，日常和线上都是 shanghai
    popRegion: env === 'pre' ? 'cn-hangzhou' : 'cn-shanghai',
    // 用户信息
    userInfo: initialState.userInfo,
    // 应用鉴权信息
    appAuthPass: initialState.appAuthPass,
    // 页面鉴权信息
    pageAuthPass: initialState.pageAuthPass || {},
    // 应用集成实例 id
    instanceId: initialState.instanceId,
    // 当前页面的应用示例配置
    instance: initialState.instance,
    // 实例鉴权信息
    instanceTokenInfo: initialState.instanceTokenInfo,
    // Web 应用的 uiMeta 信息
    uiMeta: initialState.uiMeta,
    // iot vpc 实例 id
    iotInstanceId: initialState.iotInstanceId,
    // xSurvey appkey
    xSurveyAppkey: initialState.xSurveyAppkey,
    // 发布问卷
    publishXSurveyUid: initialState.publishXSurveyUid,
    // 是否是逻辑实例中
    isLogicInstance: initialState.isLogicInstance,
};
export default config;
